module.exports = __webpack_public_path__ + "img/ARCHIVED.b4029369.svg";